module.exports = __webpack_public_path__ + "static/img/004.854af58.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/guide/ustd/004.png
// module id = 1r8j
// module chunks = 1